import React, {useEffect, useState} from "react";
import {Typography} from "@mui/material";
import css_typography from "../Common/css/Typography.module.scss";
import enterpriseObjectClassFactory from "../../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../../eoec/eo/EnterpriseObject";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../../util/Buffer";
import EventBus from "../../util/EventBus";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import OnshapeConfigurationApplet from "../../eoec/applet/impl/OnshapeConfiguration/OnshapeConfigurationApplet";
import CCButton from "../Common/CCButton";

export default function OnshapeConfiguration() {
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);
    const [onshapeConfigurationEnterpriseObject] = useState(() => enterpriseObjectClassFactory("OnshapeConfiguration") as EnterpriseObject);
    const [onshapeConfigurationBuffer, setOnshapeConfigurationBuffer] = React.useState<Map<string, any>>(new Map<string, any>());
    const [showConfigurationEditor, setShowConfigurationEditor] = React.useState(false);
    const [mode, setMode] = useState<string>("New");

    function enterpriseComponentLoadStartedListener(ec: EnterpriseComponent) {
        setBackgroundOperation(true)
    }

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec)

        if (b.length > 0) {
            setMode("Edit")
            setOnshapeConfigurationBuffer(b[0]);
        } else {
            setMode("New")
            setOnshapeConfigurationBuffer(new Map<string, any>());
        }
        setBackgroundOperation(false)
    }

    function enterpriseComponentValueChanged(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec)

        setOnshapeConfigurationBuffer(b[0]);
    }

    function onCancelHandler(e: MouseEvent) {
        setShowConfigurationEditor(false);
    }

    function onSaveHandler(e: MouseEvent) {
        setShowConfigurationEditor(false);

        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.newQuery();
        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.setIDOCRequest("v1.OnshapeConfiguration-001");
        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.setIDOCResponse("v1.OnshapeConfiguration-001");
        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.executeQuery(1, 1);
    }

    useEffect(() => {
        EventBus.components.addListener("onshape-configuration-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("onshape-configuration-form-applet-save", onSaveHandler);

        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.addValueChangedListener(enterpriseComponentValueChanged);
        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.newQuery();
        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.setIDOCRequest("v1.OnshapeConfiguration-001");
        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.setIDOCResponse("v1.OnshapeConfiguration-001");
        onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")?.executeQuery(1, 1);

        return () => {
            EventBus.components.removeListener("onshape-configuration-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("onshape-configuration-form-applet-save", onSaveHandler);

            onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")!.removeValueChangedListener(enterpriseComponentValueChanged);
            onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")!.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")!.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        }
    }, [onshapeConfigurationEnterpriseObject]);

    function renderEditor() {
        if (showConfigurationEditor && mode === "New") {
            return <OnshapeConfigurationApplet enterpriseComponent={onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")} defaultAction="New"/>
        } else if (showConfigurationEditor) {
            return <OnshapeConfigurationApplet enterpriseComponent={onshapeConfigurationEnterpriseObject.getEnterpriseComponent("OnshapeConfiguration")} defaultAction="Edit" />
        }
    }
    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1, width: "100%"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%", marginBottom: "5px", marginRight: "20px"}}>
                <div style={{width: "100%"}}>
                    <Typography style={{fontSize: "22px", fontWeight: "500", color: "#1498D8"}}>Onshape Configuration</Typography>
                </div>
            </div>
            <div style={{border: "1px solid #EDEFF3", width: "calc(100% - 22px)", padding: "10px 10px 10px 10px", borderRadius: "5px"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "250px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Part Document Type:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{onshapeConfigurationBuffer.get("PartDocumentTypeNamePlusAcronym") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "250px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Part Form:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{onshapeConfigurationBuffer.get("PartFormDocumentRevisionDocumentIDPlusRevision") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "250px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Assembly Document Type:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{onshapeConfigurationBuffer.get("AssemblyDocumentTypeNamePlusAcronym") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "250px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Assembly Form:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{onshapeConfigurationBuffer.get("AssemblyFormDocumentRevisionDocumentIDPlusRevision") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "250px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Approval Request Document Type:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{onshapeConfigurationBuffer.get("ARDocumentTypeNamePlusAcronym") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "250px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Approval Request Form:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{onshapeConfigurationBuffer.get("ARFormDocumentRevisionDocumentIDPlusRevision") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "250px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Webhook URL:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{onshapeConfigurationBuffer.get("WebhookURL") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "100%", marginTop: "20px"}}>
                    <CCButton
                        className={css_buttons.blueStandardButton}
                        style={{cursor: "pointer", height: "35px", width: "150px"}}
                        size="small"
                        animate={backgroundOperation}
                        onClick={() => {
                            setShowConfigurationEditor(true);
                        }}>
                        <Typography style={{margin: "0 0 0 6px", fontSize: "13px", fontWeight: 500, color: "#FFFFFF"}}>{onshapeConfigurationBuffer.size === 0 ? "New" : "Edit"} Configuration</Typography>
                    </CCButton>
                    {renderEditor()}
                </div>
            </div>
        </div>
    );
}